import Vue from 'vue'
import { mapState, mapGetters } from 'vuex'

Vue.mixin({
  computed: {
    ...mapState(['app', 'user']),
    ...mapGetters(['isLogin'])
  }
})
